import React from 'react';

import { LoaderIcon } from '@vlabs/icons';
import type { TFileDropzoneFile } from '@vlabs/monokit/features/file-with-detections-viewer/FileWithDetectionsViewer';
import type { TDetection } from '@vlabs/shared/components/photo-upload-form';
import { PhotoUploadFormComponent } from '@vlabs/shared/components/photo-upload-form';

import st from './ReferenceSelector.module.sass';
import { useSearchPageTranslation } from '../../i18n';

interface SdkDescriptorSearchProps {
  file: TFileDropzoneFile | undefined;
  detections: TDetection[] | undefined;
  isLoading: boolean;
  maxImageSize?: number | null;
  selectedDetections: TDetection[];
  onFileSelect: (file: TFileDropzoneFile) => void;
  onResetFile: () => void;
  onSelectSampleId: (ids: string[]) => void;
  setSelectedDetections: React.Dispatch<React.SetStateAction<TDetection[]>>;
}

function SdkDescriptorSearch({
  file,
  detections,
  isLoading,
  maxImageSize = undefined,
  selectedDetections,
  onFileSelect,
  onResetFile,
  onSelectSampleId,
  setSelectedDetections,
}: SdkDescriptorSearchProps): React.JSX.Element {
  const { t } = useSearchPageTranslation();

  let noDetectionsMessage: string | undefined;
  if (detections?.length === 0) {
    noDetectionsMessage = t('reference_selector.error.no_detections');
  }

  return (
    <React.Fragment>
      <div className={st.PhotoUploadFormWrapper}>
        <PhotoUploadFormComponent
          detections={detections}
          errorProps={{ errors: { message: noDetectionsMessage } }}
          file={file}
          maxImageSize={maxImageSize}
          onFileSelect={onFileSelect}
          onResetFile={onResetFile}
          onSelectSampleId={onSelectSampleId}
          selectedStateProps={{ selectedDetections, setSelectedDetections }}
        />
      </div>

      {!!isLoading && (
        <div className={st.Loading}>
          <LoaderIcon />
          <div>{t('reference_selector.image_input.loader.label')}</div>
        </div>
      )}
    </React.Fragment>
  );
}

export { SdkDescriptorSearch };
